import axios from "axios";

const jsonConfig = {
  headers: {
    Accept: "application/json",
  },
};

const mapPaginatedPosts = (data, key) => ({
  items: data?.results?.[key] || [],
  count: data?.count || 0,
  next: data?.next || null,
  previous: data?.previous || null,
});

export async function fetchCategories() {
  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/api/category/list`,
    jsonConfig
  );
  return res?.data?.categories || [];
}

export async function fetchBlogList(page) {
  const query = page ? `?p=${page}` : "";
  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/api/blog/list${query}`,
    jsonConfig
  );
  return mapPaginatedPosts(res.data, "posts");
}

export async function fetchBlogListByCategory(slug, page) {
  const query = page ? `&p=${page}` : "";
  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/api/blog/by_category?slug=${slug}${query}`,
    jsonConfig
  );
  return mapPaginatedPosts(res.data, "posts");
}

export async function fetchBlogDetail(slug) {
  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/api/blog/detail/${slug}`,
    jsonConfig
  );
  return res?.data?.post || null;
}

export async function fetchBlogSearch(term, page) {
  const query = page ? `?p=${page}&s=${term}` : `?s=${term}`;
  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/api/blog/search${query}`,
    jsonConfig
  );
  return mapPaginatedPosts(res.data, "filtered_posts");
}

export async function fetchJobList(page) {
  const query = page ? `?p=${page}` : "";
  const res = await axios.get(
    `${process.env.REACT_APP_EXTERNAL_API_URL}/api/job/main/${query}`,
    jsonConfig
  );
  return {
    items: res?.data?.results?.jobs || [],
    count: res?.data?.count || 0,
    next: res?.data?.next || null,
    previous: res?.data?.previous || null,
  };
}

export async function fetchJobDetail(id) {
  const res = await axios.get(
    `${process.env.REACT_APP_EXTERNAL_API_URL}/api/job/main/${id}/`,
    jsonConfig
  );
  return res?.data?.job || null;
}
